import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { profileQKeys } from "@hooks/queries/profile/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  profileId: string;
  profileData: FormData;
}

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ profileId, profileData }: MutationProps) => {
      return api.patch(`profile/${profileId}`, profileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-profile-success",
      });
      queryClient.invalidateQueries({
        queryKey: profileQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Profile]", res);
      handleErrors(res, "mutation");
    },
  });
};
